import { IconLayer } from '@deck.gl/layers';
import { Geometry } from 'geojson';

import { Optional } from '@angular/core';

import { FsLprCamera } from '../../api/models';

interface ILprCamera {
  properties: {
    id: string;
    name: string;
    heading: number;
    provider: string;
    last_event: string;
  };
  geometry: Geometry;
}

export class FsLprCameraWebGlMarkerLayer {
  private _iconLayer: IconLayer;

  constructor(public data: FsLprCamera[] | ILprCamera[], @Optional() public options?: any) {
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    const filteredData = (data as ILprCamera[]).filter((camera) => {
      // Check if last_event exists and is valid
      if (!camera.properties?.last_event) {
        return true; // Include cameras without last_event (like FlockV3)
      }

      const lastEvent = new Date(camera.properties.last_event);
      const isValidDate = !isNaN(lastEvent.getTime());

      if (!isValidDate) {
        return true; // Include cameras with invalid dates
      }

      return lastEvent.getTime() >= thirtyDaysAgo.getTime();
    });
    this._iconLayer = new IconLayer({
      id: 'fs__lpr-webgl-marker',
      data: filteredData,
      getIcon: (d) => {
        const icon = {
          url: `/assets/fusus-icons/PNG/${this._getCameraIcon(d).makeIcon}.png`,
          width: 20,
          height: 20,
          anchorY: 10,
          anchorX: 10,
        };
        return icon;
      },
      pickable: true,
      sizeScale: 5,
      getPosition: (d) =>
        d.position?.coordinates || [d.geometry.coordinates[0], d.geometry.coordinates[1]],
      getSize: () => 3,
      ...options,
    });
  }

  public getLayer(): IconLayer {
    return this._iconLayer;
  }

  private _getCameraIcon(item: any): any {
    const provider = item.type || item.properties.provider;
    switch (true) {
      case provider.toString()?.toLowerCase() === 'fs alpr':
      case provider.toString()?.toLowerCase() === 'flock safety':
        return { makeIcon: 'Icon_FS', hasIcon: true };
      case provider.toString()?.toLowerCase()?.includes('genetec'):
      case provider.toString()?.toLowerCase()?.includes('genetec sharp3'):
      case provider.toString()?.toLowerCase()?.includes('genetec sharp5'):
        return { makeIcon: 'Icon_Genetec', hasIcon: true };
      case provider.toString()?.toLowerCase()?.includes('vigilant'):
        return { makeIcon: 'Icon_Vigilant', hasIcon: true };
      case provider.toString()?.toLowerCase()?.includes('rekor'):
        return { makeIcon: 'Icon_Rekor', hasIcon: true };
      case provider.toString()?.toLowerCase()?.includes('dronesense'):
        return { makeIcon: 'Icon_DroneSense', hasIcon: true };
      case provider.toString()?.toLowerCase()?.includes('epic'):
        return { makeIcon: 'EPIC-IO', hasIcon: true };
      case provider.toString()?.toLowerCase() === 'elsag':
        return { makeIcon: 'Elsag', hasIcon: true };
      case provider.toString()?.toLowerCase() === 'rt alpr':
        return { makeIcon: 'Icon_LPAR', hasIcon: true };
      case provider.toString()?.toLowerCase() === 'insight lpr':
        return { makeIcon: 'Insight_Lpr2', hasIcon: true };
      default:
        return { makeIcon: 'FususALPR', hasIcon: false };
    }
  }
}
